import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function BuvContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  buvId,
  getSingleBuv,
  buvInfo,
  getLandClassificationsList,
  landClassificationsList,
}) {
  useEffect(() => {
    if (_.isEmpty(buvId)) return;
    getSingleBuv(buvId);
    getLandClassificationsList();
  }, []);
  useEffect(() => {
    if (_.isEmpty(buvId)) return;
    getSingleBuv(buvId);
    getLandClassificationsList();
  }, [buvId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(buvInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-10">
                  <h3 className="">Information</h3>
                </div>
                <div className="col-2 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(buvInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(buvInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom">
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">Location:</label>
                            <span className="full-input">
                              {_.get(
                                buvInfo,
                                'attributes.rptax_location_name'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">District:</label>
                            <span className="full-input">
                              {_.get(
                                buvInfo,
                                'attributes.rptax_district_name'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        {/* <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Street Code:
                            </label>
                            <span className="full-input">
                              {_.get(buvInfo, 'attributes.street_code') || '--'}
                            </span>
                          </div>
                        </div> */}
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Street From:
                            </label>
                            <span className="full-input">
                              {_.get(buvInfo, 'attributes.street_from_name') ||
                                _.get(buvInfo, 'attributes.street_from') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Street To:
                            </label>
                            <span className="full-input">
                              {_.get(buvInfo, 'attributes.street_to_name') ||
                                _.get(buvInfo, 'attributes.street_to') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Land Classification:
                            </label>
                            <span className="full-input">
                              {landClassificationsList.find(
                                (item) =>
                                  +item.id ===
                                  +_.get(
                                    buvInfo,
                                    'attributes.land_classification_id'
                                  )
                              )?.attributes?.name || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Sub-Classification:
                            </label>
                            <span className="full-input">
                              {_.get(
                                buvInfo,
                                'attributes.land_sub_classification_code'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Ordinance Revision:
                            </label>
                            <span className="full-input">
                              {_.get(
                                buvInfo,
                                'attributes.ordinance_revision_name'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Unit Value:
                            </label>
                            <span className="full-input">
                              {_.get(buvInfo, 'attributes.unit_value') || '--'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

BuvContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  getSingleBuv: PropTypes.instanceOf(Function).isRequired,
  buvInfo: PropTypes.instanceOf(Object).isRequired,
  buvId: PropTypes.string.isRequired,
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  landClassificationsList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  buvInfo: _.get(api, `${c.GET_SINGLE_BUV}.item`) || {},
  buvId: _.get(match, 'params.buvId') || '',
  landClassificationsList:
    _.get(api, `${c.GET_LAND_CLASSIFICATIONS}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuvContent);
